<template>
  <div>
    <EmailsListDetail />
  </div>
</template>

<script>

import EmailsListDetail from '@/febos/global/emails/components/emails/EmailsListDetail';

export default {
  name: 'Emails',
  components: {
    EmailsListDetail
  },
  data() {
    return {
      filter: null
    };
  }
};
</script>

<style>

</style>
